import React, { Component, useEffect, useState } from "react";

import "./App.css";

import Amplify from "aws-amplify";
import { AmplifyAuthenticator, AmplifySignIn, AmplifySignOut } from "@aws-amplify/ui-react";
import awsExports from "./aws-exports";

import ReactPlayer from "react-player";
import Countdown from "react-countdown";
import { Auth } from "aws-amplify/lib-esm";

Amplify.configure(awsExports);

class Header extends Component {
  render() {
    return (
      <div>
        <header className="App-header">
          {this.props.children}
        </header>
        <AmplifySignOut />
      </div>
    );
  }
}

const App = () => {
  const [user, setUser] = useState(false);
  const [ready, setReady] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [intervalID, setIntervalID] = useState();

  const validateUser = () => {
    const { Username } = JSON.parse(user);
    if (Username) {
      postData('https://mzhkohsaib.execute-api.us-east-1.amazonaws.com/prod/test', { Username })
        .then((data) => {
          if (data.statusCode !== 200) { Auth.signOut(); return }
        });
    }
  }

  const fetchStreaming = () => {
    const usr = localStorage.getItem('CognitoIdentityServiceProvider.33gfmsa3jjh2acjfccf7dc5r5j.0bfc409a-e7a5-406c-8499-55b9338cd936.userData');
    if (!usr) return;
    setUser(usr);
    fetch('https://r4gtc752zbk3bl.data.mediastore.us-east-1.amazonaws.com/p/index.m3u8')
      .then((response) => response.text())
      .then((data) => {
        const boolean = data.search('#EXT-X-STREAM-INF') !== -1;
        setReady(boolean);
        if (boolean === true)
          clearInterval(intervalID);
      }).catch();
  }
  
  useEffect(() => {
    validateUser();
    setIntervalID(setInterval(fetchStreaming, 10 * 1000))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(user)
      validateUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <AmplifyAuthenticator>
      <AmplifySignIn slot="sign-in" hideSignUp />
      <Header>
        <h1>Athenas - Alfa y Omega USA Tour</h1>
        {ready !== true && <h3 className="App-title">Streaming starts in <Countdown date={new Date('2022-10-01T20:30:00-04:00')} /></h3>}
        {ready === true && <ReactPlayer
          controls
          loop
          light
          onClickPreview={() => setPlaying(true)}
          playing={playing}
          url='https://r4gtc752zbk3bl.data.mediastore.us-east-1.amazonaws.com/p/index.m3u8'
        />}
      </Header>
    </AmplifyAuthenticator>
  );
};

async function postData(url = '', data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    // credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    // redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

export default App;